import { PDFDownloadLink } from '@react-pdf/renderer';
import Wedding from './Wedding';

 const WeddingQuotationPDF = ({ pdfData }) => {
    const fileName = "WeddingQuotation.pdf";
   return (
     <div>
            <div className='download-link'>
                <PDFDownloadLink
                    document={<Wedding pdfData={pdfData} />}
                    fileName={fileName}
                    style={{ color: '#fff!important' }}
                >
                   <center><button className='text-light btn btn-sm btn-success m-3'>Download Quotation</button></center>
                </PDFDownloadLink>
            </div>
     </div>
   )
 }
 
 export default WeddingQuotationPDF